import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type DisplaySettings = {
  showOwners: boolean;
};

type DisplaySettingsStore = DisplaySettings & {
  setShowOwners: (show: boolean) => void;
  resetSettings: () => void;
};

const DEFAULT_SETTINGS: DisplaySettings = {
  showOwners: false,
};

export const useDisplaySettingsStore = create<DisplaySettingsStore>()(
  persist(
    (set) => ({
      ...DEFAULT_SETTINGS,
      setShowOwners: (show) => set({ showOwners: show }),
      resetSettings: () => set(DEFAULT_SETTINGS),
    }),
    {
      name: 'display-settings',
    }
  )
);
